import axios from 'axios';
import { API_BASE_URL } from '../config/api';

axios.defaults.withCredentials = true;

const authService = {
  // Get Microsoft Graph authorization URL
  async getAuthUrl() {
    try {
  const response = await axios.get(`${API_BASE_URL}/auth/login?prompt=select_account`, { withCredentials: true });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to get authorization URL');
    }
  },

  // Exchange authorization code for access token
  async exchangeCodeForToken(code, state = null) {
    try {
      const response = await axios.post(`${API_BASE_URL}/auth/callback`, {
        code,
        state
      }, { withCredentials: true });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to exchange code for token');
    }
  },

  // Get user profile using access token
  async getUserProfile(accessToken) {
    try {
      const response = await axios.get(`${API_BASE_URL}/auth/profile`, {
        headers: {
          'Authorization': `Bearer ${accessToken}`
        },
        withCredentials: true
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to get user profile');
    }
  },

  // Refresh access token
  async refreshToken(refreshToken) {
    try {
      const response = await axios.post(`${API_BASE_URL}/auth/refresh`, {
        refreshToken
      }, { withCredentials: true });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to refresh token');
    }
  },

  // Logout user
  async logout() {
    try {
  const response = await axios.post(`${API_BASE_URL}/auth/logout`, {}, { withCredentials: true });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to logout');
    }
  },

  // Check authentication status
  async getAuthStatus() {
    try {
  const response = await axios.get(`${API_BASE_URL}/auth/status`, { withCredentials: true });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to get auth status');
    }
  }
};

export default authService;